import React, { type JSX } from 'react';
import MuiListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import { Link } from 'react-router';
import EDIconButton from '../../Buttons/IconButton/EDIconButton';
import { IconType } from '../../Icon/Utils/IconDefinitions';

interface IProps {
  to: string;
  children: JSX.Element | IconType;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  testId?: string;
  classes?: any;
}

const styles = (theme: Theme) => ({
  action: {
    right: theme.spacing(0),
    transform: 'inherit' as 'inherit',
    position: 'inherit' as 'inherit',
  },
  link: {
    textDecoration: 'none',
  },
  icon: {
    padding: `calc(${theme.spacing(0.5)} + 1px)`,
    margin: theme.spacing('auto', '1px', 'auto', '-1px'), // FIXME: Jag är inte förtjust i "hack"-ishness, i denna.
  },
});

const EDLinkListItemSecondaryAction: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = (props: IProps) => (
  <MuiListItemSecondaryAction
    classes={{
      root: props.classes.action,
    }}
    data-testid={props.testId}
  >
    <Link to={props.to} className={props.classes.link}>
      <EDIconButton
        tooltip=""
        onClick={props.onClick ? props.onClick : () => {}}
        icon={props.children}
        className={props.classes.icon}
        invertColorOnHover
        margin="none"
      />
    </Link>
  </MuiListItemSecondaryAction>
);

export default withStyles(EDLinkListItemSecondaryAction, styles);
